import { Subject } from 'rxjs';
import { Toro } from '../api/common/enumerations';
import { User } from '../api/models/user.model';

/***********************************************************************************************************************
 *
 * The purpose of this class is to act as an intermediary for broadcasting events to any and all other services.
 * Place any events in this service that one may want to broadcast out to multiple consumers simultaneously.
 *
 *
 * NOTE: No other services should be injected into this class. This class should only be consumed by other services
 *       or components.
 *
 **********************************************************************************************************************/
export class BroadcastService {

    // Events
    public userSignedOut = new Subject<User>();

    public showPopupDialog = new Subject<{documentType: Toro.DocumentType, data?: any}>();

}
